import { CancellationToken } from "@multiweb/types/multiweb";
import { IClassItemRights } from "../../../Global/Base/Rights/IClassItemRights";
import { IItemRights, IItemRightsCollection } from "../../../Global/Base/Rights/RightTypes";
import { NullOWObject, OWObject } from "../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { OWManager } from "../../../OW.Remoting/Remoting/OWManager";
import { RequestContext } from "../../../OW.Remoting/Remoting/RequestContext";
import { ClassItemRightTypes, ClassItemType, IEvaluatedConditionResult } from "../../../OW.Remoting/Remoting/Rights";
import { ComponentRightsExtractor } from "./ComponentRightsExtractor";

export class Rights {
    /**
     * Vyhodnocení všech práv na dané komponentě
     * @param applyConditionResults Příznak, zda se mají pro právo viditelnosti aplikovat vyhodnocené výsledky podmínek. Často odpovídá - pokud máme objekt, pak je true
     */
    // TODO-rites: old rights, deprecated
    public static evaluateControlRights(rightCollection: IItemRightsCollection, classItemsRightsResult: Map<string, IClassItemRights>, evaluatedConditions: IEvaluatedConditionResult[], attrName: string, userRoleID: any[], applyConditionResults: boolean): IClassItemRights {
        let cir: IClassItemRights = null;

        if (attrName) {
            const aktItemRight: IClassItemRights = classItemsRightsResult.get(attrName);
            if (aktItemRight)
                cir = {
                    Enabled: aktItemRight.Enabled,
                    PostponedRequired: aktItemRight.PostponedRequired,
                    Recommended: aktItemRight.Recommended,
                    Required: aktItemRight.Required,
                    Visible: aktItemRight.Visible,
                    OpenAsEnabled: aktItemRight.OpenAsEnabled,
                    Name: aktItemRight.Name,
                    Type: aktItemRight.Type,
                };
        }

        if (cir == null)
            cir = {
                Enabled: true,
                PostponedRequired: false,
                Recommended: false,
                Required: false,
                Visible: true,
                closeForm: false,
                validate: false,
                confirm: false,
                useDigitalSign: false,
                useEncryption: false,
                useDecryption: false,
                OpenAsEnabled: false,
                Name: "",
                Type: null,
            };

        cir.Enabled = Rights.evaulatePartOfCondition(rightCollection.enabled, rightCollection, cir.Enabled, evaluatedConditions, "or", userRoleID);
        cir.PostponedRequired = Rights.evaulatePartOfCondition(rightCollection.postponedRequired, rightCollection, cir.PostponedRequired, evaluatedConditions, "or", userRoleID);
        cir.Recommended = Rights.evaulatePartOfCondition(rightCollection.recommended, rightCollection, cir.Recommended, evaluatedConditions, "or", userRoleID);
        cir.Required = Rights.evaulatePartOfCondition(rightCollection.required, rightCollection, cir.Required, evaluatedConditions, "or", userRoleID);
        cir.closeForm = Rights.evaulatePartOfCondition(rightCollection.closeForm, rightCollection, cir.closeForm, evaluatedConditions, "or", userRoleID);
        cir.validate = Rights.evaulatePartOfCondition(rightCollection.validateIf, rightCollection, cir.validate, evaluatedConditions, "or", userRoleID);
        cir.confirm = Rights.evaulatePartOfCondition(rightCollection.confirmIf, rightCollection, cir.confirm, evaluatedConditions, "or", userRoleID);
        cir.useDigitalSign = Rights.evaulatePartOfCondition(rightCollection.useDigitalSign, rightCollection, cir.useDigitalSign, evaluatedConditions, "or", userRoleID);
        cir.useEncryption = Rights.evaulatePartOfCondition(rightCollection.useEncryption, rightCollection, cir.useEncryption, evaluatedConditions, "or", userRoleID);
        cir.useDecryption = Rights.evaulatePartOfCondition(rightCollection.useDecryption, rightCollection, cir.useDecryption, evaluatedConditions, "or", userRoleID);
        cir.OpenAsEnabled = Rights.evaulatePartOfCondition(rightCollection.openAsEnabled, rightCollection, cir.OpenAsEnabled, evaluatedConditions, "or", userRoleID);
        cir.Visible = Rights.evaluateVisibility(rightCollection.visible, rightCollection, cir.Visible == null ? true : cir.Visible, evaluatedConditions, "and", userRoleID, applyConditionResults);

        return cir;
    }

    /**
     * Vyhodnotí konkrétní předané právo
     * @param rightsDefinition definice všech práv komponenty
     * @param specificRight konkrétní právo, které se má vyhodnotit
     * @param contextObject objekt, nad kterým se má právo vyhodnotit, nebo null pro vyhodnocení statické
     * @param classItemName název atributu nebo metody, ke které se právo váže, nebo null, pokud požadované právo nevztahuje ani k jednomu, ale pouze ke komponentě
     * @param classItemType typ prvku třídy - metoda nebo atribut - nebo null
     * @param requestContext Viz {@link RequestContext}
     */
    // TODO-rites: old rights, deprecated; c2: z některých míst se stále volá
    public static async evaluateSpecificControlRights(rightsDefinition: IItemRightsCollection, specificRight: ReadonlyArray<IItemRights>, contextObject: OWObject,
        classItemName: string = null, classItemType: ClassItemType = null, requestContext?: RequestContext): Promise<IClassItemRights> {
        const promises: Promise<IEvaluatedConditionResult>[] = [];
        const evaluateConditionFunc: (conditionId: string, requestContext?: RequestContext | CancellationToken) => Promise<boolean> = contextObject && !(contextObject instanceof NullOWObject) ? contextObject.evaluateCondition.bind(contextObject) : OWManager.evaluateConditionWithoutObject.bind(OWManager);

        for (const r of specificRight) {
            if (r.conditionID == null)
                continue;

            promises.push(evaluateConditionFunc(r.conditionID, requestContext).then((result: boolean) => ({ Result: result, ID: r.conditionID })));
        }
        const evaluatedConditions = await Promise.all(promises);

        // toto by často nemělo být potřeba - nemá cenu vyhodnocovat práva rozhraní pro typy práv, které jsou jen pro formulář
        if (classItemName && classItemType) {
            const itemsRightResult: Map<string, IClassItemRights> = new Map();
            const itemRight = await contextObject.itemRights(classItemName, classItemType, ClassItemRightTypes.all);
            itemsRightResult.set(classItemName, itemRight);
            //var itemsRightResult = await OWManager.$$$_MethodToDelete_$$$_GetClassItemsRights(this.Owner.ActualObject, this.classItemsRights);
            return Rights.evaluateControlRights(rightsDefinition, itemsRightResult, evaluatedConditions, classItemName, await OWManager.getUserRoleIDs(requestContext?.cancellationToken), true);
        }

        return Rights.evaluateControlRights(rightsDefinition, null, evaluatedConditions, null, await OWManager.getUserRoleIDs(requestContext?.cancellationToken), true);
    }

    // TODO-rites: old rights, deprecated
    public static evaluateVisibility(rights: ReadonlyArray<IItemRights>, rightCollection: IItemRightsCollection, itemsRightsResult: boolean, evaulatedConditions: IEvaluatedConditionResult[], _operator: string, userRoleID: any[], applyConditionResults: boolean): boolean {
        if (applyConditionResults)
            return Rights.evaulatePartOfCondition(rights, rightCollection, itemsRightsResult, evaulatedConditions, "and", userRoleID);
        else {
            if (rights == undefined)
                return true;

            for (let i = 0; i < rights.length; i++) {
                const aktRight = rights[i];
                if (aktRight && aktRight.conditionID) {
                    return rightCollection.showIfDefault;
                }
            }
            return true;
        }
    }

    //Vyhodnocení jedné skupiny práv (visible, enabled ...) na komponentě
    // TODO-rites: old rights, deprecated
    public static evaulatePartOfCondition(rights: ReadonlyArray<IItemRights>, _rightCollection: IItemRightsCollection, itemsRightsResult: boolean, evaulatedConditions: IEvaluatedConditionResult[], operator: string, userRoleID: any[]): boolean {
        if (!rights || !ComponentRightsExtractor.hasSomeValidRightToEvaluate(rights, userRoleID))
            return itemsRightsResult;

        let value: boolean = operator === "and";

        for (let i = 0; i < rights.length; i++) {
            const aktRight = rights[i];
            let newValue: boolean = null;

            if (aktRight && aktRight.conditionID) {
                if (!evaulatedConditions)
                    newValue = false;
                else {
                    for (let j = 0; j < evaulatedConditions.length; j++) {
                        if (evaulatedConditions[j].ID === aktRight.conditionID) {
                            newValue = evaulatedConditions[j].Result;
                            break;
                        }
                    }
                    //Pokud nebyla podminka spravne vyhodnocena, tak je automaticky false
                    if (newValue == null)
                        return false;
                }
            } else {
                if (aktRight && aktRight.value != null)
                    newValue = aktRight.value;
            }
            if (newValue != null) {
                if (aktRight.isNegative)
                    newValue = !newValue;
                value = operator === "and" ? value && newValue : value || newValue;

                if ((operator === "and" && !value) || (operator === "or" && value))
                    break;
            }
        }

        if (operator === "and")
            return itemsRightsResult && value;
        else
            return itemsRightsResult || value;
    }
}
